import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexedDBService {

  private _db?: IDBDatabase;
  private _dbInitializationPromise?: Promise<IDBDatabase>;

  constructor() {
    this._openDatabase('cloud-fe', 1).then(db => {
      this._db = db;
    });
  }

  private _openDatabase(name: string, version: number): Promise<IDBDatabase> {
    if (this._db) {
      return Promise.resolve(this._db);
    }

    if (this._dbInitializationPromise) {
      return this._dbInitializationPromise;
    }

    this._dbInitializationPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open(name, version);
  
      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains('settings')) {
          db.createObjectStore('settings', { keyPath: 'key' });
          db.transaction('settings', 'readwrite').objectStore('settings').add({ key: 'dontShowInstallPrompt', value: true });
        }
      };
  
      request.onsuccess = (event) => {
        resolve((event.target as IDBOpenDBRequest).result);
      };
  
      request.onerror = (event) => {
        reject((event.target as IDBOpenDBRequest).error);
      };
    });

    return this._dbInitializationPromise;
  }

  public setSettings(key: string, value: any): Promise<void> {
    return this._openDatabase('cloud-fe', 1).then((db) => { 
      return new Promise((resolve, reject) => {
        if (!db) {
          return reject('Database not initialized');
        }

        const transaction = db.transaction('settings', 'readwrite');
        const store = transaction.objectStore('settings');
        const request = store.put({ key: key, value: value });
    
        request.onsuccess = () => {
          resolve();
        };
    
        request.onerror = (event) => {
          reject((event.target as IDBRequest).error);
        };
      });
    });
  }

  public getSettings(key: string): Promise<any> {
    return this._openDatabase('cloud-fe', 1).then((db) => {
      return new Promise((resolve, reject) => {
        if (!db) {
          return reject('Database not initialized');
        }
  
        const transaction = db.transaction('settings', 'readonly');
        const store = transaction.objectStore('settings');
        const request = store.get(key);
  
        request.onsuccess = (event) => {
          resolve((event.target as IDBRequest).result?.value ?? false);
        };
  
        request.onerror = (event) => {
          reject((event.target as IDBRequest).error);
        };
      });
    });
  }

}
